import { CustomException, elk } from '@tencent/ppd-base-libs';
type Obj = {
  [x: string]: any
};
interface ReportParams {
  url: string;
  params: Obj;
  res: Obj;
}

/**
 * 从res解析获得errCode
 * 异常码来自retcode或者result
 */
const getErrCode = (res: Obj) => {
  const { retcode, result } = res;
  const errCode = retcode !== '0' && retcode ? retcode : result;
  return errCode;
};

/**
 * 获取cgi名称
 * @param url
 * @returns
 */
export const getCgiName = (url: string) => {
  const reg = new RegExp(/[a-z]+(_[a-z]+){2,3}/g);
  const result = reg.exec(url);
  const targetCgiName = result?.[0];
  return targetCgiName || url;
};

/**
 * 进行elk上报（格式化）
 */
const doReport = ({ url, params, res }: ReportParams) => {
  elk({
    key: getCgiName(url),
    msg: JSON.stringify(res),
    errCode: getErrCode(res),
    str4: JSON.stringify(params), // 请求参数
    str2: 'ajax',
    str3: params.dp_page, // 请求页面
    str5: params.dp_positions, // 请求位置
    str1: 'dpLoader-',
  });
};

/**
 * 处理并生成CustomException
 */
const handleCustomException = ({ url, res, params }: ReportParams) => {
  const targetCgiName = getCgiName(url);
  const exceptionObj = JSON.stringify({ cgi: getCgiName(url), params, res });
  // 因为这里创建自定义告警的第二个字段不能使用动态参数，所以要这样new CustomException
  switch (targetCgiName) {
    case 'query_dp_message':
      new CustomException(exceptionObj, 'dpLoader-queryDpMessageByPosIdError', '页面查询投放信息失败');
      break;
    case 'query_dp_message_bydpid':
      new CustomException(exceptionObj, 'dpLoader-queryDpMessageByPosIdByDpIdError', '查询指定投放信息失败');
      break;
    case 'sumbit_check_value':
      new CustomException(exceptionObj, 'dpLoader-submitCheckValueError', '投放接口上报失败');
      break;
    default:
      new CustomException(exceptionObj, 'dpLoader-dpSystemError', '查询接口失败');
  }
};

/** 进行投放接口的自定义上报 */
export const reportElk = ({ url = '', params = {}, res = {} }: ReportParams) => {
  try {
    doReport({ url, params, res });
    if (getErrCode(res) !== '0') {
      handleCustomException({ url, params, res });
    }
    return;
  } catch (e) {
    new CustomException(e, 'dpLoader-dpSystemReportError', '投放接口自定义上报错误');
  }
};

// 背景：
// 三个投放接口需要主动format elk上报与告警。errCode，key,并且禁用原来的base-lib request的上报。
// 比如，正常：
// {"retcode": "0", "retmsg": "OK", "result":"0","res_info":"成功","dp_channel":1,"dp_page":"110004000021","dp_list":[{"dp_position":"1100040000210005","dp_id":850002051,"component_id":390,"component_url":"https://st.moneydata.hk/res/weixin/hkwallet/cmp_center/prod/wphk-components-monorepo/0.0.1/demo.umd.min.js","content_base_data":"{\"content\":\"测试投放-需要兜底的位置-非兜底计划-超出兜底投放的时间区间-测试修改-每天固定时间区间生效\"}","is_bi":2,"item_data":[]},{"dp_position":"1100040000210006","dp_id":850002053,"component_id":390,"component_url":"https://st.moneydata.hk/res/weixin/hkwallet/cmp_center/prod/wphk-components-monorepo/0.0.1/demo.umd.min.js","content_base_data":"{\"content\":\"测试投放-兜底位置2-非兜底计划-更新修改时间\"}","is_bi":2,"item_data":[]},{"dp_position":"1100040000210006","dp_id":850002052,"component_id":390,"component_url":"https://st.moneydata.hk/res/weixin/hkwallet/cmp_center/prod/wphk-components-monorepo/0.0.1/demo.umd.min.js","content_base_data":"{\"content\":\"兜底计划2\"}","is_bi":2,"item_data":[]}],"msg_no":"616007f3b091661762076299360001"}
// 比如，投放侧网关异常1： 少传了一个参数
// {"retcode": "0", "retmsg": "OK", "result":"1611954402","res_info":"参数错误","dp_list":[]}
// 投放侧网关异常2：传的参数格式不对
// {
//   "retcode": "1057110005",
//   "retmsg": "抱歉，当前使用人数较多导致系统繁忙，请刷新页面重试或稍后再试"
// }
